export function calculatePurchaseQuantity(values = {}) {
  if (values.purchase_type === 'package') {
    const packages = Number(values.package_count || 0);
    const perPackage = Number(values.licenses_per_package || 0);
    return packages > 0 && perPackage > 0 ? packages * perPackage : 0;
  }

  const quantity = Number(values.quantity || 0);
  return quantity > 0 ? quantity : 0;
}

export function calculatePurchaseTotalCost(values = {}) {
  if (values.purchase_type === 'package') {
    const packages = Number(values.package_count || 0);
    const price = values.package_price;
    if (packages <= 0 || price === null || price === undefined || price === '') return null;
    return packages * Number(price);
  }

  const quantity = Number(values.quantity || 0);
  const price = values.unit_price;
  if (quantity <= 0 || price === null || price === undefined || price === '') return null;
  return quantity * Number(price);
}

export function purchaseQuantityLabel(purchase) {
  if (purchase.purchase_type === 'package') {
    return `${purchase.package_count} × ${purchase.licenses_per_package} = ${purchase.quantity}`;
  }
  return String(purchase.quantity ?? 0);
}
